import React from "react";
import { ApolloClient, InMemoryCache, ApolloProvider, ApolloLink, HttpLink } from '@apollo/client';
import ReactDOM from "react-dom";
import "./styles/tailwind.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { bootstrapPwa } from "./services/pwa";
import { initSentry } from "./services/sentry";
import { setupLogging } from "./setupLogging";
import "react-tooltip/dist/react-tooltip.css"; //needed for react-tooltip

// Sentry first so its breadcrumb capture wraps console.* before setupLogging no-ops them.
initSentry();
setupLogging();

// Block introspection queries so they don’t clutter console
const blockIntrospectionLink = new ApolloLink((operation, forward) => {
  if (operation.operationName === "IntrospectionQuery") {
    // Skip introspection queries
    return null;
  }
  return forward(operation);
});

// HTTP link to your API
const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

// Initialize Apollo Client
const client = new ApolloClient({
  link: ApolloLink.from([blockIntrospectionLink, httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: true, // keep devtools enabled
});


ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

bootstrapPwa();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
